package de.connect2x.timmy.web

import de.connect2x.lognity.api.backend.Backend
import de.connect2x.lognity.backend.DefaultBackend
import de.connect2x.lognity.config.CoreConfigExtension
import de.connect2x.lognity.config.SerializableConfig
import de.connect2x.lognity.config.withDefaultConfig
import de.connect2x.timmy.BuildConfig
import de.connect2x.timmy.GlobalCustomConfig
import de.connect2x.timmy.loadConfig
import de.connect2x.timmy.setFavicon
import de.connect2x.timmy.setTitle
import de.connect2x.timmy.timmyConfiguration
import de.connect2x.trixnity.messenger.compose.view.startMultiMessenger
import io.ktor.http.Url
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import web.location.location

suspend fun main(): Unit = coroutineScope {
    Backend.set(DefaultBackend)
    SerializableConfig uses CoreConfigExtension
    val config = loadConfig()
    setTitle(config.brand.appName)
    setFavicon(config.brand.faviconPath)
    GlobalCustomConfig.CSV_EXPORT_DISABLED = config.csvExportDisabled
    GlobalCustomConfig.filePreviewDisabled = config.filePreviewDisabled
    Backend.withDefaultConfig("lognity.json") {
        launch {
            startMultiMessenger {
                timmyConfiguration(
                    BuildConfig.spec,
                    overrideVzdUrl = Url(config.vzdUrl),
                    overrideIdpUrl = Url(config.idpUrl),
                    overrideVersionCheckUrl = Url(config.versionCheckUrl),
                    overrideHomeServerUrl = config.homeServerUrl.takeIf { it.isNotEmpty() },
                    disableDownloads = config.downloadsDisabled,
                    branding = config.brand,
                )
                // web: redirect URLs (SSO, OAuth2) must point back to this web client, not the native app scheme
                appUri = location.origin
                messengerConfiguration {
                    appUriSsoRedirect = "sso.html"
                    appUriOAuth2Redirect = "oauth2.html"
                }
            }
        }
    }
}
